import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { LinkItem } from '../link-item';

const PRIVACY_POLICY_LINK: LinkItem = {
  label: 'Privacy Policy',
  href: 'https://www.securitas.com/en/about-us/securitas-technology-and-healthcare-global-privacy-policy',
};

@Component({
  selector: 'core-nav-footer',
  imports: [],
  template: `
    <div
      class="bg-2 h-16 w-full items-center shadow-2xl flex"
      data-testid="footer"
    >
      <span class="p-4" i18n="@@copyright">
        &copy;{{ currentYear }} 3xLOGIC, Inc. All Rights Reserved.</span
      >
      <div class="ml-auto" data-testid="links">
        @for (
          item of allLinks();
          track item;
          let i = $index;
          let isLast = $last
        ) {
          <a class="text-accent p-4" [href]="item.href" target="_blank">{{
            item.label
          }}</a>
          @if (!isLast) {
            <span>|</span>
          }
        }
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationFooterComponent {
  public links = input<LinkItem[]>([]);
  protected readonly allLinks = computed(() => [
    PRIVACY_POLICY_LINK,
    ...this.links(),
  ]);
  protected readonly currentYear = new Date().getFullYear();
}
